var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartNewOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;}.cls-1,.cls-2{stroke-width:0.5px;}.cls-2{fill:#d68828;stroke:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M56.4,56.23h-11a1.13,1.13,0,0,1,0-2.26h11a.48.48,0,0,0,.48-.47s0-.07,0-.1L50.41,24.27a1.14,1.14,0,0,1,2.22-.5h0L59.1,52.93A2.76,2.76,0,0,1,57,56.19a2.6,2.6,0,0,1-.56.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-1",
    d: "M45.45,56.22H15.11a2.75,2.75,0,0,1-2.75-2.76,2.47,2.47,0,0,1,.05-.54l5.81-29.08a2.76,2.76,0,0,1,2.71-2.21h29a2.76,2.76,0,0,1,2.76,2.75,2.42,2.42,0,0,1-.06.54L46.57,55.31A1.15,1.15,0,0,1,45.45,56.22ZM20.93,23.91a.46.46,0,0,0-.47.38L14.64,53.36a.48.48,0,0,0,.38.56h29.5l5.89-29.46a.48.48,0,0,0-.38-.56H20.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-2",
    d: "M42.22,27.15A1.14,1.14,0,0,1,41.08,26v-9.7a5.32,5.32,0,1,0-10.64,0h0V26a1.14,1.14,0,0,1-2.27,0V16.32a7.6,7.6,0,1,1,15.2,0V26a1.12,1.12,0,0,1-1.12,1.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartNewOrderIcon);
export default __webpack_public_path__ + "static/media/start-new-order-icon.717d37a33dd838fca10c606d5dce26bb.svg";
export { ForwardRef as ReactComponent };